export class StockVarianceDto {
  stockId: number;
  varianceValue: string;
  stockLevelId?: number;
  countedDateTimePrev?: Date;
  countedDateTime?: Date;
}
